import { MarketRegion, type Market } from "@dotcom/markets";

const isNaMarket = (market: Market) => {
  return market.region === MarketRegion.NorthAmerica;
};

export default isNaMarket;
